/**
 * Máy chủ đang cập nhật (deploy / khởi động lại): nginx trả 502/503/504 kèm CORS.
 * Trong lúc này mọi thông báo lỗi được thay bằng một thông báo duy nhất, dễ hiểu, thay vì "mất kết nối"
 * hay lỗi kỹ thuật của từng trang.
 */
export const SERVICE_UPDATING_MESSAGE = 'Hệ thống đang cập nhật phiên bản mới, vui lòng đợi ít phút rồi thao tác lại.';
export const SERVICE_UPDATING_TOAST_ID = 'service-updating';
const UPDATING_WINDOW_MS = 90_000;

let updatingUntil = 0;

/** Mã cổng / máy chủ tạm không phục vụ */
export function isGatewayDownStatus(status: unknown): boolean {
  const n = Number(status);
  return n === 502 || n === 503 || n === 504;
}

export function markServiceUpdating(now = Date.now()): void {
  updatingUntil = now + UPDATING_WINDOW_MS;
}

export function isServiceUpdating(now = Date.now()): boolean {
  return now < updatingUntil;
}

/** Chỉ dùng trong test */
export function resetServiceUpdating(): void {
  updatingUntil = 0;
}
